var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('v-container',{attrs:{"fluid":""}},[_c('p',{staticClass:"copyright font-sarabun"},[_vm._v(" Copyright © 2025 tsa.shopping All rights reserved. Version 0.0.01 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }